import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const projectSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'projects': {
    id: 'projects',
    getMenuItemDisplayValue: Messages.column_numChildren,
    subSortOptions: {
      'desc': {
        id: 'projects.desc',
        field: OrderKeys.childProjectCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumChildrenDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.childProjectCount), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'projects.asc',
        field: OrderKeys.childProjectCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumChildrenAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.childProjectCount), Order.asc(OrderKeys.name)]
      }
    }
  },
  'workbooks': {
    id: 'workbooks',
    getMenuItemDisplayValue: Messages.column_numWorkbooks,
    subSortOptions: {
      'desc': {
        id: 'workbooks.desc',
        field: OrderKeys.workbookCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumWorkbooksDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.workbookCount), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'workbooks.asc',
        field: OrderKeys.workbookCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumWorkbooksAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.workbookCount), Order.asc(OrderKeys.name)]
      }
    }
  },
  'views': {
    id: 'views',
    getMenuItemDisplayValue: Messages.column_numViews,
    subSortOptions: {
      'desc': {
        id: 'views.desc',
        field: OrderKeys.viewCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumViewsDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.viewCount), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'views.asc',
        field: OrderKeys.viewCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumViewsAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.viewCount), Order.asc(OrderKeys.name)]
      }
    }
  },
  'datasources': {
    id: 'datasources',
    getMenuItemDisplayValue: Messages.sortByDataSourcesCount,
    subSortOptions: {
      'desc': {
        id: 'datasources.desc',
        field: OrderKeys.datasourceCount,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumDatasourcesDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.datasourceCount), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'datasources.asc',
        field: OrderKeys.datasourceCount,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumDatasourcesAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.datasourceCount), Order.asc(OrderKeys.name)]
      }
    }
  },
  'owner': SortOptions.owner,
  'created': {
    id: 'created',
    getMenuItemDisplayValue: Messages.column_created,
    subSortOptions: {
      'desc': {
        id: 'created.desc',
        field: OrderKeys.createdAt,
        getMenuItemDisplayValue: Messages.sortByNewest,
        getButtonDisplayValue: Messages.sortByCreatedNewest,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.createdAt)]
      },
      'asc': {
        id: 'created.asc',
        field: OrderKeys.createdAt,
        getMenuItemDisplayValue: Messages.sortByOldest,
        getButtonDisplayValue: Messages.sortByCreatedOldest,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.createdAt)]
      }
    }
  }
  // projects DO NOT support relevance sort order
};
